// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 17L10 7L15 12L10 17Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretRight.js.map